import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { StoreService } from './services/store.service';
import { LoadingModalComponent } from './shared/components/modals/loading-modal/loading-modal.component';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	title = 'ng-obd-admin';

	private _currentDialogRef: MatDialogRef<LoadingModalComponent> | null = null;

	constructor(
		private _storeService: StoreService,
		private _dialog: MatDialog
	) {
		this._storeService.toggleDialog$.subscribe((isToggleOpen) => {
			if (isToggleOpen) {
				this._openLoaderDialog();
			} else {
				this._closeLoaderDialog();
			}
		});
	}

	private _openLoaderDialog(): void {
		const dialogRef = this._dialog.open(LoadingModalComponent, {
			panelClass: 'transparent',
			// width: '35vw',
			disableClose: true
		});
		this._currentDialogRef = dialogRef;
	}

	private _closeLoaderDialog(): void {
		if (this._currentDialogRef) {
			(this._currentDialogRef as MatDialogRef<LoadingModalComponent>).close();
			this._currentDialogRef = null;
		}
	}
}
